import { NumericFormat, OnValueChange } from 'react-number-format';

import TextInput, { TextInputProps } from '@/components/TextInput/TextInput';

interface Props extends TextInputProps {
  type?: 'password' | 'tel' | 'text';
  allowNegative?: boolean;
  defaultValue?: string | number;
  onValueChange?: OnValueChange;
}

export const NumericField: React.FC<Props> = ({
  label,
  labelFor,
  placeholder,
  type,
  icon,
  img,
  textError,
  isError,
  required,
  onChange,
  onKeyDown,
  onClickIcon,
  onFocusInput,
  onValueChange,
  value,
  allowNegative = false,
}) => {
  return (
    <NumericFormat
      value={value}
      customInput={TextInput}
      thousandSeparator=" "
      allowNegative={allowNegative}
      decimalSeparator=","
      label={label}
      labelFor={labelFor}
      placeholder={placeholder}
      type={type}
      icon={icon}
      img={img}
      textError={textError}
      isError={isError}
      required={required}
      onChange={onChange}
      onKeyDown={onKeyDown}
      onClickIcon={onClickIcon}
      onFocusInput={onFocusInput}
      onValueChange={onValueChange}
    />
  );
};
